import { createStyles, rem } from '@mantine/core'

export interface StylesParams {
  numberItem: number
  blockName: string
}

export default createStyles(
  (theme, { blockName, numberItem }: StylesParams) => {
    return {
      navigatorWrapper: {},
      navigatorRoot: {
        display: 'flex',
        ...(blockName == 'ElegantUI'
          ? {
              flexWrap: 'wrap',
              gap: rem(12),
              [theme.fn.smallerThan('sm')]: {
                flexDirection: 'column',
                gap: rem(8),
              },
            }
          : {
              gap: rem(24),
              ...(numberItem > 3 && {
                flexWrap: 'wrap',
              }),
              [theme.fn.largerThan('sm')]: {
                gap: numberItem > 3 ? rem(12) : rem(24),
              },
              [theme.fn.smallerThan('sm')]: {
                gap: rem(8),
              },
            }),
      },
      navigatorItem: {
        ...(blockName === 'ElegantUI'
          ? {
              [theme.fn.largerThan('sm')]: {
                width: `calc((100% - 12px)/2)`,
                minHeight: rem(102),
              },
            }
          : {
              ...(numberItem === 1 && {
                maxWidth: rem(360),
              }),
              ...(numberItem <= 3 && {
                width: '100%',
                flexGrow: 1,
              }),
              ...(numberItem === 4 && {
                width: `calc((100% - 36px)/4)`,
                flexGrow: 0,
                [theme.fn.smallerThan('sm')]: {
                  width: `calc((100% - 16px)/2)`,
                },
              }),
              ...(numberItem > 4 && {
                width: `calc((100% - 36px)/4)`,
                flexGrow: 0,
                [theme.fn.smallerThan('sm')]: {
                  width: `calc((100% - 16px)/3)`,
                },
              }),
              [theme.fn.largerThan('sm')]: {
                ...(numberItem > 3 && {
                  padding: rem(12),
                  gap: rem(12),
                }),
              },
            }),
      },
      navigatorItemImgWrapper: {
        ...(blockName !== 'ElegantUI' && {
          [theme.fn.largerThan('sm')]: {
            ...(numberItem > 3 && {
              width: rem(40),
              height: rem(40),
              borderRadius: rem(12),
            }),
          },
        }),
      },
      navigatorItemTitle: {
        ...(blockName !== 'ElegantUI' && {
          [theme.fn.largerThan('sm')]: {
            ...(numberItem > 3 && {
              fontSize: '14px',
              lineHeight: '18px',
            }),
          },
        }),
      },
    }
  },
)
